<template>
    <div class="help-element" v-html="content" />
</template>

<script>
import * as DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    // Enable target="_blank" on anchors, and automatically include rel="noopener".
    if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
    }
});

export default {
    props: {
        schema: {
            required: true,
            type: [Object, Boolean]
        },
        uischema: {
            required: true,
            type: Object
        },
        path: {
            required: true,
            type: String
        },
        enabled: {
            required: false,
            type: Boolean,
            default: undefined
        },
        renderers: {
            required: false,
            type: Array,
            default: undefined
        },
        cells: {
            required: false,
            type: Array,
            default: undefined
        },
        config: {
            required: false,
            type: Object,
            default: undefined
        }
    },
    computed: {
        content: function () {
            return DOMPurify.sanitize(this.uischema.text)
        }
    }
}
</script>
